var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[(_vm.wick.url)?[_c('a',{attrs:{"href":_vm.wick.url}},[_vm._v("\n      "+_vm._s(_vm.wick.name)+"\n    ")])]:[_vm._v("\n    "+_vm._s(_vm.wick.name)+"\n  ")],_vm._v("\n\n  "+_vm._s(_vm.wick.suffix)+"\n")],2)}
var staticRenderFns = []

export { render, staticRenderFns }